import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import App from './App.vue'
import router from './router.ts'
import '@/styles/element/index.scss'

const app = createApp(App)
app.use(router).use(ElementPlus, { size: 'large', zIndex: 3000 }).mount('#app')